/**
 * InvoiceListHeader — S11 page title and primary actions.
 *
 * @see prototype/sales/invoices.html — page-head
 */
import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { Plus, Upload } from "lucide-react";
import { Button } from "@flint/ui";
import { ImportInvoicesDialog } from "../components/import-dialog.tsx";

export interface InvoiceListHeaderProps {
  lead: string | null;
  canCreate?: boolean;
}

export function InvoiceListHeader({ lead, canCreate = true }: InvoiceListHeaderProps) {
  const [importOpen, setImportOpen] = useState(false);
  return (
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <h1 className="text-xl font-semibold text-ink">Invoices</h1>
        {lead ? (
          <p className="mt-0.5 text-sm text-muted">{lead}</p>
        ) : (
          <p className="mt-0.5 text-sm text-muted">
            Tax invoices, append-only with gap-free numbering.
          </p>
        )}
      </div>
      <div className="flex items-center gap-2">
        {canCreate && (
          <Button
            type="button"
            intent="ghost"
            onClick={() => setImportOpen(true)}
            title="Import invoices from a CSV or XLSX file"
          >
            <Upload size={14} />
            <span>Import</span>
          </Button>
        )}
        {canCreate && (
          <Button asChild>
            <Link to="/sales/invoices/new">
              <Plus size={14} />
              <span>New invoice</span>
            </Link>
          </Button>
        )}
      </div>
      <ImportInvoicesDialog open={importOpen} onOpenChange={setImportOpen} />
    </header>
  );
}
